// extracted by mini-css-extract-plugin
module.exports = {"additionalInformation":"additional-information__4sPkC","additionalInformationWrapper":"additional-information__wrapper__3Lx84"};